// extracted by mini-css-extract-plugin
module.exports = {"Image_container":"image_Image_container__1cK_Y","Image_fallback":"image_Image_fallback__375Mp","dim":"image_dim__1aS3c"};